<a
  *ngIf="permissionService.hasPermissions(permissions) && condition"
  class="tw-font-semibold tw-text-sbBlue-500"
  [class]="classes"
  [sbRouterLink]="link"
  [pathParams]="pathParams"
  [queryParams]="queryParams"
  [ngbTooltip]="tooltip"
  container="body"
  [placement]="tooltipPlacement"
  [container]="tooltipContainer">
  <span [innerHtml]="title"></span>
</a>

<span class="tw-font-semibold" *ngIf="!permissionService.hasPermissions(permissions) || !condition"
      [class]="classes" [innerHtml]="title"></span>
